function VerifyHrefContent(params) {
  // 創建一個新的 URLSearchParams 來保存驗證後的參數
  const sanitizedParams = new URLSearchParams();

  // 迭代所有參數並進行驗證
  for (const [key, value] of params) {
    // 檢查鍵和值是否包含合法字符
    if (IsValidInput(key) && IsValidInput(value)) {
      // 將合法的參數加入到驗證後的參數中
      sanitizedParams.append(key, value);
    }
  }

  return sanitizedParams;
}

// 驗證輸入是否包含合法字符
function IsValidInput(input) {
  // 排除特定字符，允許英文日文中文等其他符號，for路標名稱
  const disallowedCharsRegex = /[<>\"']/;
  return !disallowedCharsRegex.test(input);
}

// 將特殊字符進行 HTML 轉義，防止 XSS 攻擊
function VerifyHtml(str) {
  // 使用 textContent 處理 HTML 特殊字符
  const div = document.createElement("div");
  div.textContent = str;
  return div.innerHTML;
}

let map;
let lists = {
  IndustryList: null,
  TownList: null,
  AirArea: [
    {
      id: "65000,63000,10003,10017",
      name: "北部空品區",
    },
    {
      id: "10018,10004,10005",
      name: "竹苗空品區",
    },
    {
      id: "66000,10007,10008",
      name: "中部空品區",
    },
    {
      id: "67000,10009,10010,10020",
      name: "雲嘉南空品區",
    },
    {
      id: "64000,10013",
      name: "高屏空品區",
    },
    {
      id: "10002",
      name: "宜蘭空品區",
    },
    {
      id: "10014,10015",
      name: "花東空品區",
    },
    {
      id: "10016,09020,09007",
      name: "離島地區",
    },
  ],
  RiverBasinList: area,
};
let places_changed;
let river = area.filter((a) => a.PARENT_ID === 0).map((a) => ({ Id: a.ID, Name: a.TEXT, categories: [] }));
let filter_type = 1;
let filter_obj = {
  type: "",
  Keyword: "",
  PollutionType: "WAT,WAS,TOX,AIR",
  Town: "",
  AirArea: "",
  location: "",
  placeId: "",
  IsPenalty: "",
  IsGreenhouse: "",
  Lat: "",
  Lng: "",
  IndustryGroup: "",
  Distance: "1",
  FactOrder: "",
  ReportItem: "",
  ReportValue: "",
  ReportStartDate: "",
  ReportEndDate: "",
  RiverBasin: "",
  Column: "All",
  PageNumber: 1,
  PageSize: 0,
};

let fetchData = {
  StartDate: "",
  EndDate: "",
};

let pageData = [];
let pageDataRaw = [];
let paginationList = [];
let singlePageSize = 5;
let currentPageNo = 1;
let isShowMap = false;

window.onload = function () {
  //   if (window.innerWidth <= 1024) {
  //     location.href = new URL(location.origin + "/info.html" + location.search);
  //   }
  page_loader(true);
  RefreshUrlParams();
  PageInit();
  Search();
  addEventListener("beforeprint", (event) => {
    $(".print_date span").text(moment().format("YYYY/MM/DD HH:mm:ss"));
  });
};

function PageInit() {
  FilterInputInit();
  PollutionTypeFilterInit();
  PaginationSelectInit();
  MobileInit();

  $(".dropdown_option > li > a").click(function () {
    let li = $(this).parent("li");
    if (li.hasClass("open")) {
      $(li).removeClass("open");
    } else {
      $(li).addClass("open");
    }
  });

  localStorage.setItem("selected_items", JSON.stringify([]));

  $(".map_btn").click(function () {
    selected_items = JSON.parse(localStorage.getItem("selected_items"));
    let map_data = [];
    selected_items.forEach((selected) => {
      let filter = pageData.filter((d) => d.RegistrationNo === selected);
      if (filter.length > 0) map_data.push(filter[0]);
    });
    let show = $(this).hasClass("map_show");
    if (filter_obj.Column === "WasteItem" && map_data.length === 0 && !show) {
      $.getJSON(`${fileHost}/${filter_obj.Keyword}.json`)
        .then((res) => {
          ShowMap = show_map($(this), res, res, "");
        })
        .fail((error) => {
          if (error.status === 404) {
            $(".modal_map_error").css("display", "flex");
            $(".modal_map_error .title").text("請至少勾選一筆列管事業。");
            $(".modal_map_error .text").text("");
          }
        });
    } else {
      if (map_data.length === 0 && filter_obj.Column !== "WasteItem") {
        $(".modal_map_error").css("display", "flex");
        $(".modal_map_error .title").text("請至少勾選一筆列管事業。");
        $(".modal_map_error .text").text("");
      } else {
        ShowMap = show ? show_map($(this), pageData, pageData, "") : show_map($(this), map_data, map_data, "");
      }
    }
  });

  $(".modal_confirm, .close_btn").click(function (e) {
    e.stopPropagation();
    e.preventDefault();
    $(".modal_notification").fadeOut();
    $(".input > input, .input > textarea").val("");
    sendMail = {};
  });

  $(".open_tab").click(function (e) {
    e.preventDefault();
    let href = $(this).data("href");
    let download = $(this).hasClass("download_button");
    let selected_items = JSON.parse(localStorage.getItem("selected_items"));
    if (selected_items.length === 0) {
      $(this).find(".modal_notification").fadeIn();
      $(this).find(".modal_notification").css("display", "flex");
    } else {
      if (download) {
        /// 下載的數量限100筆資料
        if (selected_items.length > 100) {
          $(this).parent().find(".modal_notification").fadeIn();
          $(this).parent().find(".modal_notification").css("display", "flex");
        } else {
          let form = document.getElementById("info_download_form");
          form.action = `${host}api/v1/Factory/ExportList`;
          let registrationNoList = document.getElementById("info_download_registrationno_list");
          registrationNoList.value = selected_items;
          form.addEventListener("submit", function (event) {
            event.preventDefault();
            window.open(form.action);
          });
          form.submit();
        }
      } else {
        window.open(href, "_blank").focus();
      }
    }
  });
}

function Search() {
  page_loader(true);
  $.ajax({
    url: `${host}/api/v1/Factory?${GetUrlParams()}`,
    type: "GET",
    headers: {
      Accept: "application/json",
    },
    success: function (res) {
      pageData = res.Result.Data;
      pageDataRaw = res.Result.Data;
      RefreshTable(pageData.slice(0, 5));
      CreatePagination(pageDataRaw.length);

      const titleElement = document.querySelector(".search_result_block > .title");
      titleElement.innerHTML = "";

      if (!!!res.Error) {
        if (res.Result.Data.length > 0) {
          const resultNumElement = document.createElement("span");
          resultNumElement.className = "result_num";
          resultNumElement.textContent = pageDataRaw.length;

          titleElement.textContent = "找到 ";
          titleElement.appendChild(resultNumElement);
          titleElement.appendChild(document.createTextNode(" 筆列管事業"));

          $(".result_block .data_block").slideDown();
        } else {
          titleElement.textContent = `找到 ${pageDataRaw.length} 筆列管事業`;
          $(".result_block .data_block").slideUp();
        }
      } else {
        $(".page_search_block .search_result_block > .desc").slideUp();
        $(".flex_block .result_block .data_block").slideUp();
        if (!tabletMediaQuery.matches) {
          $(".page_search_block .search_result_block > .btn_group").slideUp();
        }
        $(".page_search_block .search_result_block > .no_data").fadeIn();
      }

      page_loader(false);
    },
  });
}

function ChangeUrlSearch() {
  if (!isNaN(filter_obj.ReportValue)) {
    let url = new URL(window.location.origin + window.location.pathname);
    Object.keys(filter_obj).forEach(function (key) {
      if (!!filter_obj[key]) {
        url.searchParams.set(key, filter_obj[key]);
      }
    });
    window.location = url;
  } else {
    $(".modal_notification .title").text("申報量欄位僅接受半形數字輸入，可包含小數點。請勿使用中文字符，請重新輸入。");
    $(".modal_notification").fadeIn();
    $(".modal_notification").css("display", "flex");
  }
}

// 更新搜尋元素
function RefreshUrlParams() {
  let params = new URLSearchParams(document.location.search);
  Object.keys(filter_obj).forEach(function (key) {
    if (!!params.get(key.toLowerCase())) {
      filter_obj[key] = params.get(key.toLowerCase());
    }
    if (!!params.get(key)) {
      filter_obj[key] = params.get(key);
    }
    if (!!params.get(key.slice(0, 1).toLowerCase() + key.slice(1))) {
      filter_obj[key] = params.get(key.slice(0, 1).toLowerCase() + key.slice(1));
    }
  });
  filter_obj.PageSize = 0;
  if (!!!filter_obj.PollutionType) filter_obj.PollutionType = "WAT,WAS,TOX,AIR";
  if (!!!filter_obj.FactOrder) filter_obj.FactOrder = "RegistrationNo";
}

// 取得搜尋URL
function GetUrlParams() {
  let newSearch = "";
  Object.keys(filter_obj).forEach(function (key) {
    if (!!filter_obj[key]) {
      newSearch += `${key}=${filter_obj[key]}&`;
    }
  });
  return newSearch;
}

// 刷新Table
function RefreshTable(obj) {
  const dataCheckList = document.querySelector(".data_check_list");
  dataCheckList.innerHTML = ""; // Clear existing content
  let fragment = document.createDocumentFragment();

  obj.forEach(function (item) {
    let liElement = document.createElement("li");

    let checkButtonDiv = document.createElement("div");
    checkButtonDiv.className = "check_button";

    let labelElement = document.createElement("label");
    labelElement.className = "script";

    let inputElement = document.createElement("input");
    inputElement.type = "checkbox";
    inputElement.name = "";
    inputElement.value = item.RegistrationNo;
    inputElement.addEventListener("click", function () {
      SearchItemClick(this);
    });

    let spanElement = document.createElement("span");
    spanElement.className = "geekmark";

    labelElement.appendChild(inputElement);
    labelElement.appendChild(spanElement);

    checkButtonDiv.appendChild(labelElement);

    let linkElement = document.createElement("a");
    const sanitizedParams = VerifyHrefContent([["id", item.RegistrationNo]]);
    linkElement.href = `detail.html?${sanitizedParams.toString()}`;
    linkElement.title = `另開新視窗，至「${item.FacilityName}」`;
    linkElement.target = "_blank";

    let dataIdDiv = document.createElement("div");
    dataIdDiv.className = "data_id";
    dataIdDiv.textContent = item.RegistrationNo;

    let titleDiv = document.createElement("div");
    const sanitizedTitle = VerifyHtml(item.FacilityName).toString();
    titleDiv.className = "title";
    titleDiv.innerHTML = `${sanitizedTitle.replaceAll(VerifyHtml(filter_obj.Keyword), `<span class='keyword'>${VerifyHtml(filter_obj.Keyword)}</span>`)} </div>`;

    let descDiv = document.createElement("div");
    descDiv.className = "desc";
    descDiv.textContent = `${item.IndustryAreaName} / ${item.IndustryName} / ${item.FacilityAddress}`;

    let labelGroupsUl = document.createElement("ul");
    labelGroupsUl.className = "label_groups";
    if (item.IsAir) {
      let isAirLi = document.createElement("li");
      isAirLi.className = "isAir";
      isAirLi.textContent = "空";
      labelGroupsUl.appendChild(isAirLi);
    }
    if (item.IsWater) {
      let isWaterLi = document.createElement("li");
      isWaterLi.className = "isWater";
      isWaterLi.textContent = "水";
      labelGroupsUl.appendChild(isWaterLi);
    }
    if (item.IsWaste) {
      let isWasteLi = document.createElement("li");
      isWasteLi.className = "isWaste";
      isWasteLi.textContent = "廢";
      labelGroupsUl.appendChild(isWasteLi);
    }
    if (item.IsToxic) {
      let isToxicLi = document.createElement("li");
      isToxicLi.className = "isToxic";
      isToxicLi.textContent = "毒";
      labelGroupsUl.appendChild(isToxicLi);
    }
    if (item.IsPenalty) {
      let isPenaltyLi = document.createElement("li");
      isPenaltyLi.className = "isPenalty";
      isPenaltyLi.textContent = "裁";
      labelGroupsUl.appendChild(isPenaltyLi);
    }

    linkElement.appendChild(dataIdDiv);
    linkElement.appendChild(titleDiv);
    linkElement.appendChild(descDiv);
    linkElement.appendChild(labelGroupsUl);

    liElement.appendChild(checkButtonDiv);
    liElement.appendChild(linkElement);

    fragment.appendChild(liElement);
  });

  dataCheckList.appendChild(fragment);

  const titleElement = document.querySelector(".search_result_block > .title");
  titleElement.innerHTML = "";
  titleElement.innerHTML = `找到 <span class="result_num">${pageData.length}</span> 筆列管事業`;

  Array.from(document.querySelectorAll(".check_button.select_all input")).forEach(function (button) {
    button.checked = false;
    localStorage.setItem("selected_items", JSON.stringify([]));
  });
}

// 選擇項目
function SearchItemClick(el) {
  selected_items = JSON.parse(localStorage.getItem("selected_items"));
  if (el.checked) {
    selected_items.push(el.value);
  } else {
    let index = selected_items.indexOf(el.value);
    selected_items.splice(index, 1);
  }
  localStorage.setItem("selected_items", JSON.stringify(selected_items));
}

// 全選項目
function SearchItemClickAll(el) {
  let dataList = Array.from(document.querySelectorAll(".data_check_list input"));

  dataList.forEach(function (item) {
    item.checked = el.checked;
    if (el.checked) {
      localStorage.setItem(
        "selected_items",
        JSON.stringify(
          dataList.map(function (input) {
            return input.value;
          })
        )
      );
    } else {
      localStorage.setItem("selected_items", JSON.stringify([]));
    }
  });

  Array.from(document.querySelectorAll(".check_button.select_all input")).forEach(function (button) {
    button.checked = el.checked;
  });
}

function PaginationSelectInit() {
  document.querySelectorAll(".pagination_select .select_dropbox").forEach(function (parent) {
    Array.from(parent.children).forEach(function (child) {
      if (!child.classList.contains("disabled")) {
        let no = child.getAttribute("data-no");
        child.children[0].addEventListener("click", function () {
          singlePageSize = no === "0" ? pageData.length : parseInt(no);
          currentPageNo = 1;
          RefreshTable(pageData.slice(0, singlePageSize));
          CreatePagination(pageData.length);
          RefreshPagination();
        });
      }
    });
  });
}

// 建立換頁標籤
function CreatePagination(itemCount) {
  $(".pagination").html("");
  let maxPageNo = Math.ceil(itemCount / singlePageSize);
  paginationList = Array.from({ length: maxPageNo }, (value, index) => index + 1);

  let window = maxPageNo > 5 ? 5 : maxPageNo;
  let prevBtn = `<li class="prev disabled"><button type="button" title="上一頁" onclick="ChangePage('prev')"><img src="img/icon/chevron-left.svg" class="svg"></button></li>`;
  let nextBtn = `<li class="next ${maxPageNo == 1 ? "disabled" : ""}"><button type="button" title="下一頁" onclick="ChangePage('next')"><img class="svg" src="img/icon/chevron-right.svg"></button></li>`;

  $(".pagination").append(prevBtn);
  for (let i = 0; i < window; i++) {
    let numBtn = `<li class="${paginationList[i] == currentPageNo ? "active" : ""}"><button type="button" onclick="ChangePage(this)" title="前往第${paginationList[i]}頁">${paginationList[i]}</button></li>`;
    $(".pagination").append(numBtn);
  }
  $(".pagination").append(nextBtn);
}

function ChangePage(type) {
  switch (type) {
    case "prev":
      if (currentPageNo > 1) {
        currentPageNo--;
      }
      break;
    case "next":
      if (currentPageNo < paginationList[paginationList.length - 1]) {
        currentPageNo++;
      }
      break;
    default:
      currentPageNo = parseInt(type.innerText);
      break;
  }
  RefreshPagination();
  let startIndex = (currentPageNo - 1) * singlePageSize;
  let endIndex = (currentPageNo - 1) * singlePageSize + singlePageSize;
  RefreshTable(pageData.slice(startIndex, endIndex));
  const data_block = document.querySelector(".data_block");
  if (window.scrollY > data_block.offsetTop - 16) scrollTo(0, data_block.offsetTop - 16);
}

// 更新換頁標籤
function RefreshPagination() {
  let currentPaginationList = [];
  if (paginationList.length > 5) {
    if (currentPageNo <= 3) {
      currentPaginationList = Array.from({ length: 5 }, (value, index) => index + 1);
    } else {
      if (paginationList.slice(currentPageNo - 1).length >= 3) {
        currentPaginationList = paginationList.slice(currentPageNo - 3, currentPageNo + 2);
      } else {
        currentPaginationList = paginationList.slice(-5);
      }
    }
  } else {
    currentPaginationList = paginationList;
  }
  $(".pagination").each(function (idx, jqEl) {
    if (currentPageNo == 1) {
      jqEl.children[0].classList.add("disabled");
    } else {
      jqEl.children[0].classList.remove("disabled");
    }

    if (currentPageNo == paginationList.length) {
      jqEl.children[jqEl.childElementCount - 1].classList.add("disabled");
    } else {
      jqEl.children[jqEl.childElementCount - 1].classList.remove("disabled");
    }
    Array.from(jqEl.children).forEach(function (el, i) {
      if (i > 0 && i < jqEl.childElementCount - 1) {
        el.classList.remove("active");
        el.children[0].innerText = currentPaginationList[i - 1];
        if (parseInt(el.children[0].innerText) == currentPageNo) {
          el.classList.add("active");
        }
      }
    });
  });
}

// 列管類別篩選初始化
function PollutionTypeFilterInit() {
  $(".pollution_type").each(function (idx, jqEl) {
    Array.from(jqEl.children).forEach(function (el, i) {
      el.children[0].querySelector("input").addEventListener("change", function () {
        let filterCheckeds = {
          IsAir: false,
          IsWater: false,
          IsWaste: false,
          IsToxic: false,
        };
        let checkedCount = 0;
        Array.from(jqEl.children).forEach((obj) => {
          let checkbox = obj.querySelector("input");
          filterCheckeds[`${checkbox.value}`] = checkbox.checked;
          checkbox.checked ? checkedCount++ : checkedCount + 0;
        });
        document.querySelectorAll(".tubulation_type_no").forEach((obj) => {
          obj.innerText = checkedCount;
        });

        if (!!checkedCount) {
          pageData = pageDataRaw.filter((item) => {
            let result = false;
            Object.keys(filterCheckeds).forEach((key) => {
              if (item[key] && filterCheckeds[key]) {
                result = true;
              }
            });
            return result;
          });
          $(".result_block .data_block").slideDown();
        } else {
          pageData = [];
          $(".result_block .data_block").slideUp();
        }

        RefreshPollutionTypeTag(filterCheckeds);
        currentPageNo = 1;
        RefreshTable(pageData.slice(0, singlePageSize));
        CreatePagination(pageData.length);
        RefreshPagination();
      });
    });
  });
  RefreshPollutionTypeTag({
    IsAir: true,
    IsWater: true,
    IsWaste: true,
    IsToxic: true,
  });
}

// 刷新列管類別標籤
function RefreshPollutionTypeTag(filterList) {
  $(".label_group").empty();
  Object.keys(filterList).forEach((key) => {
    if (filterList[key]) {
      let html = "";
      let text = "";
      if (key === "IsAir") {
        text = "空氣污染";
      } else if (key === "IsWater") {
        text = "水污染";
      } else if (key === "IsWaste") {
        text = "廢棄物";
      } else if (key === "IsToxic") {
        text = "毒性化學物質";
      }
      html += `<li>
                    <button data-type=${key} onclick="ClosePollutionTypeTag('${key}')">
                        <div class="title">${text}</div>
                        <img src="img/icon/close.svg" class="svg" alt="關閉">
                    </button>
                </li>`;
      $(".label_group").append(html);
      svg_to_xml();
    }
  });
}

// 關閉列管類別標籤
function ClosePollutionTypeTag(type) {
  let inputList = document.querySelectorAll(`.pollution_type input[value="${type}"]`);
  inputList.forEach(function (input, key) {
    if (!!key) {
      $(input).trigger("click");
    } else {
      $(input).attr("checked", false);
    }
  });
}

// 篩選器初始化
function FilterInputInit() {
  let params = new URLSearchParams(document.location.search);
  let filterType = params.get("type");

  if (filterType == 2) {
    if (!tabletMediaQuery.matches) {
      $(".filter_location_input").css("display", "block");
      $(".filter_keyword_input").css("display", "none");
    } else {
      $(".filter_location").css("display", "block");
      $(".filter_keyword_input .dropdown").css("display", "none");
      $(".filter_keyword").css("display", "none");
    }

    $(".filter_type").text("地點");
    $("#filter_location").val(filter_obj.location);
    $(".filter_location").val(filter_obj.location);
  } else {
    if (!tabletMediaQuery.matches) {
      $(".filter_location_input").css("display", "none");
      $(".filter_keyword_input").css("display", "flex");
      $(".filter_keyword_input .dropdown").css("display", "block");
      $(".select_dropbox.filter_distance").parent("li").css("display", "none");
    } else {
      $(".filter_location").css("display", "none");
      $(".filter_keyword").css("display", "block");
    }
    if (filterType == 1) {
      $(".filter_type").text("關鍵字");
      $(".filter_keyword").val(filter_obj.Keyword);
      $(".filter_keyword_input .dropdown").css("display", "block");
    } else {
      $(".filter_type").text("申報量");
      $(".filter_keyword").val(filter_obj.ReportItem);
      $(".filter_keyword_input .dropdown").css("display", "none");
      $(".report_notify").text("可於關鍵字之間加空格限縮查詢範圍，例：「廢棄物及再利用資源代碼 列管事業名稱」");
    }
  }

  $(".select_input_block .list_dropdown >li ").each(function () {
    let type = $(this).children("button").data("column");
    let val = $(this).children("button").text();
    if (type === filter_obj.Column) {
      $(".select_input_block .title").text(val);
      $(this).parent("li").addClass("selected");
    }
  });

  $(".select_input_block .dropdown >button").click(function (e) {
    e.stopPropagation();
    let show = $(".select_input_block .list_dropdown").css("display");

    if (show === "none") {
      $(".select_input_block .list_dropdown").fadeIn();
    } else {
      $(".select_input_block .list_dropdown").fadeOut();
    }
  });

  $(".select_input_block .list_dropdown li>button").click(function (e) {
    e.stopPropagation();
    let text = $(this).text();
    let type = $(this).data("column");
    $(".select_input_block .list_dropdown li").removeClass("selected");
    $(this).parent("li").addClass("selected");
    $(".select_input_block .dropdown .title").text(text);
    $(".select_input_block .list_dropdown").fadeOut();
    $(".select_input_block .filter_keyword").attr("placeholder", text);
    filter_obj.Column = type;
  });

  let orderType = !!filter_obj.FactOrder ? filter_obj.FactOrder : "RegistrationNo";
  $(".btn_group>li:nth-child(2) .title").text($(`.btn_group>li:nth-child(2) li[data-value='${orderType}']>button`).text());
  $(`.btn_group>li:nth-child(2) li[data-value='${orderType}']`).addClass("selected");

  let distance = !!filter_obj.Distance ? filter_obj.Distance : "1";
  $(".btn_group>li:nth-child(1) .title").text($(`.btn_group>li:nth-child(1) li[data-distance='${distance}']>button`).text());
  $(`.btn_group>li:nth-child(1) li[data-distance='${distance}']`).addClass("selected");

  $(".filter_keyword_button").click(function () {
    document.querySelectorAll(".filter_keyword").forEach(function (el) {
      if (!!el.value) {
        if (filter_obj.type == 3) {
          filter_obj.ReportItem = el.value;
        } else {
          filter_obj.Keyword = el.value;
        }
      }
    });
    Search();
  });

  $(".filter_location.pac-target-input").click(function () {
    let location = document.getElementById("filter_location").value;
    if (!!location) {
      if (filter_obj.location !== location) {
        filter_obj.location = location;
        filter_obj.placeId = places_changed[0].place_id;
        filter_obj.Lat = places_changed[0].geometry.location.lat();
        filter_obj.Lng = places_changed[0].geometry.location.lng();
      }
    }
    ChangeUrlSearch();
  });

  //申報量資訊
  $(".dropdown_form .input_block").each(function () {
    let Class = $(this).find("input").attr("class");
    if (filter_obj.ReportItem !== "" || filter_obj.ReportItem !== "") {
      $(".reportData").addClass("open");
    }
    $(this).find("input").val(filter_obj[Class]);
  });
  if (filter_obj.ReportStartDate !== "") {
    $(".reportDateData").addClass("open");
    $(".reportDate").val(`${filter_obj.ReportStartDate} ─ ${filter_obj.ReportEndDate}`);
  }
  $(".input_block input").keyup(function () {
    let Class = $(this).attr("class");
    let val = $(this).val();
    if (Class !== "filter_keyword") {
      filter_obj[Class] = val;
    }
  });
  let ReportObj = {
    ReportItem: urlParams.get("ReportItem") ? urlParams.get("ReportItem") : "",
    ReportValue: urlParams.get("ReportValue") ? urlParams.get("ReportValue") : "",
  };
  $(".ReportItem, .ReportValue").change(function () {
    let val = $(this).val();
    let id = $(this).attr("id");
    ReportObj[id] = val;
  });
  $(".submit_btn.reportData").click(function () {
    ChangeUrlSearch();
  });
  customCalendar(filter_obj.ReportStartDate, filter_obj.ReportEndDate);
  if (mobileMediaQuery.matches) {
    $(".reportDate").attr("placeholder", "起 - 迄");
    $(".declaration_amt").attr("placeholder", "半形數字可含小數點");
  }

  // 申報日期
  $(".input_calendar_range > .calendar_input").each(function (e) {
    let type = $(this).find("input").data("type");
    $(this).find("input").val(filter_obj[type]);
  });
  $(".calendar").delegate("table td>button", "click", function (e) {
    let type = $(this).parents(".calendar_input").children("input").data("type");
    let value = $(this).parent("td").data("date");
    let selectedValue = filter_obj[type] && filter_obj[type] === value ? "" : value;

    $(this).parents(".calendar").slideUp(100);
    $(this).parents(".calendar").removeClass("open");
    filter_obj[type] = selectedValue;
    $(this).parents(".calendar_input").children("input").val(selectedValue);
    if (type === "ReportStartDate") {
      filter_obj.ReportEndDate = "";
      customCalendar(selectedValue, filter_obj.ReportEndDate ? filter_obj.ReportEndDate : "", selectedValue);
    }
    $(".input_calendar_range > .calendar_input").each(function (e) {
      let type = $(this).find("input").data("type");
      $(this).find("input").val(filter_obj[type]);
    });
    if (filter_obj.ReportStartDate && filter_obj.ReportEndDate) {
      ChangeUrlSearch();
    }
  });
  $(".calendar_input > input").keyup(function (e) {
    let value = $(this).val();
    let type = $(this).data("type");
    if (e.keyCode === 13) {
      filter_obj[type] = value;
      $(this).next(".calendar").removeClass("open");
      $(this).next(".calendar").slideUp();
      if (filter_obj.ReportStartDate && filter_obj.ReportEndDate) {
        ChangeUrlSearch();
      }
    }
  });

  //   取得清單資料
  let fetchList = [
    {
      id: "取得行業別清單",
      path: "/api/v1/Code/IndustryList",
      class: ".insutry_type",
      lists: "IndustryList",
    },
    {
      id: "取得城市清單",
      path: "/api/v1/Code/CountyTownList",
      class: ".town_type",
      lists: "TownList",
    },
  ];
  fetchList.forEach((obj) => {
    let list = obj.lists;
    $.ajax({
      url: `${host}${obj.path}`,
      type: "GET",
      headers: {
        Accept: "application/json",
      },
      success: function (data) {
        if (data.Result !== null && data.Error === null) {
          let parent_category = data.Result.filter((d) => d.ParentId === "0");
          parent_category.map((p) => {
            let id = p.Id;
            let category = data.Result.filter((d) => d.ParentId === id);
            p.categories = category;
            return p;
          });

          lists[list] = parent_category;
          parent_category.forEach((cat) => {
            let id = cat.Id;
            let parent_name = cat.Name;
            html = `<li class="${id}">
                        <button onclick="CheckAllExpandLsit(this)">
                            <label class="script">
                                <span class="title">${parent_name}</span>
                                <input type="checkbox" value="${id}" name="" id="" />
                                <span class="geekmark"></span>
                            </label>
                        </button>
                        <a href="javascript: void(0)" role="button" class="expand_dropdown">
                            <img src="img/icon/chevron-down.svg" class="svg" alt='' />
                        </a>
                        <ul class="sub_dropdown">`;
            cat.categories.forEach((child) => {
              html += `<li class="">
                                <button>
                                    <label class="script">
                                        <span class="title">${child.Name}</span>
                                        <input type="checkbox" value="${child.Id}" name="" id="" />
                                        <span class="geekmark"></span>
                                    </label>
                                </button>
                            </li>`;
            });

            html += `</ul>
                    </li>`;
            $(obj.class).append(html);
          });
          checkExpandList();
          checked_status();
        }
      },
    });
  });

  area.forEach((a) => {
    if (a.PARENT_ID !== 0) {
      let filter = river.findIndex((r) => r.Id === a.PARENT_ID);
      river[filter]["categories"].push({ Id: a.ID, Name: a.TEXT, PARENT_ID: a.PARENT_ID });
    }
  });
  river.forEach((cat) => {
    let id = cat.Id;
    let parent_name = cat.Name;
    html = `<li class="${id}">
              <button onclick="CheckAllExpandLsit(this)">
                  <label class="script">
                      <span class="title">${parent_name}</span>
                      <input type="checkbox" value="${id}" name="" id="" />
                      <span class="geekmark"></span>
                  </label>
              </button>
              <a href="javascript: void(0)" role="button" class="expand_dropdown">
                  <img src="img/icon/chevron-down.svg" class="svg" alt='' />
              </a>
              <ul class="sub_dropdown">`;
    cat.categories.forEach((child) => {
      html += `<li class="">
                  <button>
                      <label class="script">
                          <span class="title">${child.Name}</span>
                          <input type="checkbox" value="${child.Id}" name="" id="" />
                          <span class="geekmark"></span>
                      </label>
                  </button>
              </li>`;
    });

    html += `</ul></li>`;
    $(".river_area").append(html);
  });

  //展開全部; 收合全部
  $(".expand_control_btn").click(function () {
    let this_ = $(this);
    let all_li = this_.prev("ul").children("li");
    let li_no = all_li.length;

    if (li_no > 4) {
      if (this_.prev("ul").hasClass("expanded")) {
        this_.prev("ul").removeClass("expanded");
        this_.text("展開全部");
        all_li.each(function (i) {
          let a = $(this).children("a").html();
          if (i + 1 > 4) {
            $(this).css("display", "none");
          }
        });
      } else {
        this_.prev("ul").addClass("expanded");
        this_.text("收合全部");
        all_li.each(function (i) {
          let a = $(this).children("a").html();
          if (i + 1 > 4) {
            $(this).css("display", "flex");
          }
        });
      }
    }
  });

  // 展開子選項按鈕
  $(".dropdown").delegate("li > a", "click", function (e) {
    let dropdown = $(this).next("ul").hasClass("sub_dropdown");
    if (dropdown) {
      if ($(this).parent("li").hasClass("open")) {
        $(this).parent("li").removeClass("open");
      } else {
        $(this).parent("li").addClass("open");
      }
    }
  });

  // 行業類別
  $(".submit_btn.IndustryGroup").click(function () {
    let result = "";
    document.querySelectorAll(".insutry_type").forEach(function (parent, key) {
      if (key == 1) {
        Array.from(parent.children).forEach(function (child) {
          Array.from(child.querySelector(".sub_dropdown").children).forEach(function (el) {
            let input = el.querySelector("input");
            if (input.checked) {
              result += "," + input.value;
            }
          });
        });
      }
    });
    filter_obj.IndustryGroup = result.replace(",", "");
    ChangeUrlSearch();
  });

  // 縣市鄉鎮
  $(".submit_btn.Town").click(function () {
    let result = "";
    document.querySelectorAll(".town_type").forEach(function (parent, key) {
      if (key == 1) {
        Array.from(parent.children).forEach(function (child) {
          Array.from(child.querySelector(".sub_dropdown").children).forEach(function (el) {
            let input = el.querySelector("input");
            if (input.checked) {
              result += "," + input.value;
            }
          });
        });
      }
    });
    filter_obj.Town = result.replace(",", "");
    ChangeUrlSearch();
  });

  // 流域
  $(".submit_btn.RiverBasin").click(function () {
    let result = "";
    document.querySelectorAll(".river_area").forEach(function (parent, key) {
      if (key == 1) {
        Array.from(parent.children).forEach(function (child) {
          Array.from(child.querySelector(".sub_dropdown").children).forEach(function (el) {
            let input = el.querySelector("input");
            if (input.checked) {
              result += "," + input.value;
            }
          });
        });
      }
    });
    filter_obj.RiverBasin = result.replace(",", "");
    ChangeUrlSearch();
  });

  // 其他
  $(".submit_btn.OtherType").click(function () {
    let IsPenalty = false,
      IsGreenhouse = false;
    document.querySelectorAll(".other_type").forEach(function (parent, key) {
      if (key == 1) {
        IsPenalty = parent.querySelector(".IsPenalty").checked;
        IsGreenhouse = parent.querySelector(".IsGreenhouse").checked;
      }
    });
    filter_obj.IsPenalty = IsPenalty ? IsPenalty : "";
    filter_obj.IsGreenhouse = IsGreenhouse ? IsGreenhouse : "";
    ChangeUrlSearch();
  });

  // 地圖圖例
  $(".map_info>li .switch").on("keyup", function (e) {
    if (e.keyCode === 13) {
      let pollutionType = "";
      Array.from(document.querySelectorAll(".map_info>li .switch")).forEach(function (item) {
        let type = item.getAttribute("data-title");
        if (!!type) {
          pollutionType += `,${type}`;
        }
      });
      marker_toggle($(this), pollutionType.replace(",", "").split(","));
    }
  });
  $(".map_info>li .switch").on("click", function (e) {
    let pollutionType = "";
    Array.from(document.querySelectorAll(".map_info>li .switch")).forEach(function (item) {
      let type = item.getAttribute("data-title");
      if (!!type) {
        pollutionType += `,${type}`;
      }
    });
    marker_toggle($(this), pollutionType.replace(",", "").split(","));
  });

  const input = !tabletMediaQuery.matches ? document.getElementById("filter_location") : document.getElementById("filter_location_input");
  const searchBox = new google.maps.places.SearchBox(input);

  searchBox.addListener("places_changed", () => {
    places_changed = searchBox.getPlaces();
  });

  $(".filter_keyword").on("keyup", function (e) {
    if (e.keyCode == 13) {
      if (this.parentElement.parentElement.parentElement.classList.contains("outter_input_block")) {
        document.querySelectorAll(".filter_keyword").forEach(function (el) {
          if (!!el.value) {
            if (filter_obj.type == 3) {
              filter_obj.ReportItem = el.value;
            } else {
              filter_obj.Keyword = el.value;
            }
          }
        });
        Search();
      } else {
        MobileSearch();
      }
    }
  });

  $(".filter_location").on("keyup", function (e) {
    if (e.keyCode === 13) {
      MobileSearch();
    }
  });
  $("#filter_location").on("keyup", function (e) {
    if (e.keyCode === 13) {
      let location = document.getElementById("filter_location").value;
      if (!!location) {
        if (filter_obj.location !== location) {
          filter_obj.location = location;
          filter_obj.placeId = places_changed[0].place_id;
          filter_obj.Lat = places_changed[0].geometry.location.lat();
          filter_obj.Lng = places_changed[0].geometry.location.lng();
        }
      }
      ChangeUrlSearch();
    }
  });
}

function CheckAllExpandLsit(el) {
  //   console.log(el.parentElement);
  let checked = el.querySelector("input").checked;
  Array.from(el.parentElement.querySelector(".sub_dropdown").children).forEach(function (item) {
    $(item.querySelector("input")).attr("checked", checked);
  });
}

//檢查下拉選項是否對於4項；第五項後之選項將會被收合
function checkExpandList() {
  $(".dropdown").each(function () {
    let this_ = $(this);
    let li_no = $(this_).children("li").length;
    if (li_no > 4) {
      $(this_)
        .children("li")
        .each(function (i) {
          if (i + 1 > 4) {
            $(this).css("display", "none");
          }
        });
    } else {
      //檢查其他篩選條件☑️狀態
      $(this_)
        .children("li")
        .each(function (i) {
          let input = $(this).children("a").children(".script").children("input");
          let input_class = $(input).attr("class");
          if (input_class) {
            let check_status = urlParams.get(input_class) ? strToBool(urlParams.get(input_class)) : false;
            $(`.${input_class}`).attr("checked", check_status);
          }
        });
    }
  });
}

//檢查列管類別☑️狀態
function checked_status() {
  for (let i in filter_obj) {
    let key = i[0].toLowerCase() + i.slice(1);
    if (filter_obj[i] !== null) {
      if (i == "IndustryGroup" || i == "Town" || i === "RiverBasin") {
        let ClassName = i === "IndustryGroup" ? ".insutry_type" : i == "Town" ? ".town_type" : ".river_area";
        if (filter_obj[i] !== "") {
          let check_list = filter_obj[i].split(",");
          let check_arr = [];
          check_list.forEach((l) => {
            if (l !== "") {
              let parent_id = i === "IndustryGroup" ? l.substring(0, 2) : i == "Town" ? l.substring(0, 5) : l;
              if (i === "RiverBasin") {
                let filter = area.filter((a) => a.ID.toString() === l);
                if (filter.length > 0) parent_id = filter[0]["PARENT_ID"].toString();
              }
              let filter_check = check_arr.filter((c) => c.parentId === parent_id);
              if (filter_check.length === 0) {
                let obj = {
                  parentId: parent_id,
                  categories: [l],
                };
                check_arr.push(obj);
              } else {
                filter_check[0]["categories"].push(l);
              }
              $(`${ClassName} > .${parent_id} > .sub_dropdown > li`).each(function (index) {
                let input = $(this).children("button").children(".script").children("input");
                let val = $(input).val();
                if (l === val) {
                  $(input).attr("checked", true);
                }
              });
            }
          });
          check_arr = check_arr.map((check) => {
            let parent_id = check.parentId;
            //包含手機版/電腦版Menu
            check.length = $(`${ClassName} > .${parent_id} > .sub_dropdown > li`).length / 2;
            return check;
          });
          if (check_arr.length > 0) {
            $(ClassName).parent("li").addClass("open");
          }
          check_arr.forEach((check) => {
            if (check.categories.length > 0) {
              $(`${ClassName} >.${check.parentId} `).addClass("open");
            }

            if (check.length === check.categories.length) {
              $(`${ClassName} > .${check.parentId} > button >.script> input`).attr("checked", true);
            }
          });
        }
      } else if (filter_obj[i] == "true" || filter_obj[i] == "false") {
        $(`.${i}`).attr("checked", !!filter_obj[i]);
        if (filter_obj[i] == "true") {
          let parent = $(`.${i}`).parent(".script").parent("button").parent("li").parent(".dropdown").parent("li");
          let isOpen = $(parent).hasClass("open");
          if (!isOpen) {
            $(parent).addClass("open");
          }
        }
      } else if (i === "AirArea" || i === "PollutionType") {
        let ClassName = i === "AirArea" ? ".air_area" : ".pollution_type";
        let checked_no = 0;
        $(`${ClassName} input`).each(function () {
          if (filter_obj[i].indexOf($(this).val()) > -1) {
            $(this).attr("checked", true);
            checked_no += 1;
          }
        });
        if (checked_no > 0) {
          $(ClassName).parent("li").addClass("open");
        }
        if (i === "PollutionType") {
          //檢查圖例☑️狀態
          //   $(".tubulation_type_no").text(checked_no / 2);
          $(".map_info>li .switch").each(function () {
            let type = $(this).data("type");
            let title = $(this).data("title");
            let open = $(this).hasClass("open");
            if (type == 1) {
              if (filter_obj[i].indexOf(title) > -1) {
                $(this).addClass("open");
              } else {
                $(this).removeClass("open");
              }
            }
          });
        }
      }
    }
  }
}

function show_map($this, new_data, data, Class, pollutionType = undefined) {
  let map_show = Class === "" ? $($this).hasClass("map_show") : Class;
  if (!map_show) {
    $($this).addClass("map_show");
    $(".map_block").slideDown();
    $(".data_block").fadeOut();
    if (!map) {
      const baseEMAP = L.tileLayer("https://wmts.nlsc.gov.tw/wmts/EMAP/default/GoogleMapsCompatible/{z}/{y}/{x}", { minZoom: 7 });
      map = L.map("mapid", {
        layers: [baseEMAP],
        attributionControl: false,
        center: [23.604799, 120.7976256], // 台灣中心點
        zoom: 7,
      });
    } else {
      Object.keys(marker_obj).forEach(function (key) {
        marker_obj[key] = [];
      });
    }
    map.eachLayer(function (layer) {
      console.log(layer);
      if (!!layer.options.radius) {
        map.removeLayer(layer);
      }
      if (layer instanceof L.MarkerClusterGroup) {
        map.removeLayer(layer);
      }
    });
    if (filter_obj.Lat && filter_obj.Lng) {
      let radius = (!!filter_obj.Distance ? filter_obj.Distance : 1) * 1000;
      let circleA = L.circle([parseFloat(filter_obj.Lat), parseFloat(filter_obj.Lng)], {
        color: "#E11D21",
        fillColor: "#E11D21",
        fillOpacity: 0.1,
        radius: radius,
      }).addTo(map);
      map.fitBounds(circleA.getBounds());
    }
    let markers = new L.MarkerClusterGroup();
    for (let i = 0; i < data.length; i++) {
      let type = [];
      let pollution_type;
      let type_arr = ["IsAir", "IsWater", "IsWaste", "IsToxic", "MoreType"];
      type_arr.forEach((t) => {
        if (data[i][t]) {
          type.push(t);
        }
      });
      if (type.length > 1) {
        pollution_type = type.length;
      } else {
        pollution_type = type[0];
      }
      // if (typeof pollution_type === "number") {
      //   marker_obj["MoreType"].push(data[i]);
      // } else {
      //   marker_obj[pollution_type].push(data[i]);
      // }
      let icon = L.icon({
        iconUrl: typeof pollution_type === "number" ? icons["MoreType"].icon : icons[pollution_type].icon,
      });
      let marker = L.marker([data[i]["Lat"], data[i]["Lng"]], { icon: icon }).on("click", () => {
        let html = `<div class="company_info">
                    <div class="code">${data[i].RegistrationNo}</div>
                    <div class="title">${data[i].FacilityName}</div>
                    <div class="text">${data[i].IndustryAreaName} / ${data[i].IndustryName} / ${data[i].FacilityAddress} </div>
                    <ul class="label_groups">`;
        html += data[i].IsAir ? "<li class='isAir'>空</li>" : "";
        html += data[i].IsWater ? "<li class='isWater'>水</li>" : "";
        html += data[i].IsWaste ? "<li class='isWaste'>廢</li>" : "";
        html += data[i].IsToxic ? "<li class='isToxic'>毒</li>" : "";
        html += data[i].IsPenalty ? "<li class='isPenalty'>裁</li>" : "";
        $(".modal_block").fadeIn();
        $(".modal_block").css("display", "flex");
        $(".modal_block .modal_content_detail").empty();
        $(".modal_block .modal_content_detail").append(html);
        $("body").css("overflow", "hidden");
      });
      // markers.addLayer(marker);
      if (typeof pollution_type === "number") {
        marker_obj["MoreType"].push(marker);
      } else {
        marker_obj[pollution_type].push(marker);
      }
    }
    let type_arr = ["IsAir", "IsWater", "IsWaste", "IsToxic", "MoreType"];
    let new_type_arr = [];
    type_arr.forEach((t) => {
      $(`.${t}No`).text(marker_obj[t].length);
      if (!!pollutionType) {
        if (marker_obj[t].length > 0 && (pollutionType.includes(t) || t === "MoreType")) {
          marker_obj[t].forEach(function (marker) {
            markers.addLayer(marker);
          });
        }
      } else {
        marker_obj[t].forEach(function (marker) {
          markers.addLayer(marker);
        });
      }
    });
    map.addLayer(markers);

    $(".map_info_block").slideDown();
    $(".search_filter_info").slideUp();
    $(".label_group").slideUp();
    $(".page_search_block .search_result_block>.desc").slideUp();
    if (filter_type == 2) {
      if (!tabletMediaQuery.matches) {
        $(".page_search_block .search_result_block>.btn_group>li").css("display", "none");
        $(".page_search_block .search_result_block>.btn_group>li:nth-child(1)").css("display", "block");
      }
    } else {
      $(".page_search_block .search_result_block>.btn_group").slideUp();
      $(".page_search_block .search_result_block>.btn_group>li:nth-child(1)").css("display", "none");
    }
    $(".result_block .data_block").slideUp();
    let btn_html;
    if (!tabletMediaQuery.matches) {
      btn_html = `   
                    <span>列表檢視</span>
                        <img src="img/icon/list.svg" class="svg" alt=''>`;
    } else {
      btn_html = `   
                    <div class='title'>列表檢視</div>
                        <img src="img/icon/list.svg" class="svg" alt=''>`;
      $($this).parent(".btn_group").addClass("map_show_phone");
    }
    $($this).empty();
    $($this).append(btn_html);

    if (data.length !== new_data.length) {
      $(".search_result_block>.title").empty();
      $(".search_result_block>.title").append(`找到 <span class="result_num">${data.length}</span> 筆列管事業，可於分布地圖定位者 <span class="result_num">${new_data.length}</span> 筆`);
    } else {
      $(".search_result_block>.title").empty();
      $(".search_result_block>.title").append(`找到 <span class="result_num">${data.length}</span> 筆列管事業`);
    }
    if (!markerCircle) {
      if (filter_obj.placeId !== "") {
        // let bounds = new google.maps.LatLngBounds();
        const request = {
          placeId: filter_obj.placeId,
          fields: ["ALL"],
        };
      }
    }
  } else {
    $($this).removeClass("map_show");
    let btn_html;
    if (!tabletMediaQuery.matches) {
      btn_html = `   
                    <span>地圖檢視</span>
                    <img src="img/icon/map.svg" class="svg" alt='' >`;
    } else {
      btn_html = `   
                    <div class='title'>地圖檢視</div>
                    <img src="img/icon/map.svg" class="svg" alt='' >`;
      $($this).parent(".btn_group").removeClass("map_show_phone");
    }
    $($this).empty();
    $($this).append(btn_html);
    $(".map_block").slideUp();
    $(".map_info_block").slideUp();
    $(".page_search_block .search_result_block>.desc").slideDown();
    $(".search_filter_info").slideDown();
    $(".label_group").slideDown();

    if (filter_type == 2) {
      if (!tabletMediaQuery.matches) {
        $(".page_search_block .search_result_block>.btn_group>li").css("display", "block");
      }
    } else {
      if (!tabletMediaQuery.matches) {
        $(".page_search_block .search_result_block>.btn_group").slideDown();
        $(".page_search_block .search_result_block>.btn_group>li:nth-child(1)").css("display", "none");
      }
    }
    $(".search_result_block>.title").empty();
    $(".search_result_block>.title").append(`找到 <span class="result_num">${data.length}</span> 筆列管事業`);
    $(".result_block .data_block").slideDown();
    $(".print_date span").text(moment().format("YYYY/MM/DD HH:mm:ss"));
  }
  svg_to_xml();
  return !map_show;
}

// 地圖標籤過濾
function marker_toggle($this, pollutionType) {
  let type = $($this).data("type");
  let title = $($this).data("title");
  let open = $($this).hasClass("open");
  if (type == 1) {
    if (open) {
      $($this).removeClass("open");
      pollutionType = pollutionType.filter((t) => t !== title);
    } else {
      $($this).addClass("open");
      let check_duplicate = pollutionType.filter((t) => t == title);
      if (check_duplicate.length === 0) {
        pollutionType.push(title);
      }
    }
    pollutionType = pollutionType.map(function (type) {
      type = type.replace("AIR", "IsAir");
      type = type.replace("WAT", "IsWater");
      type = type.replace("WAS", "IsWaste");
      type = type.replace("TOX", "IsToxic");
      return type;
    });
    selected_items = JSON.parse(localStorage.getItem("selected_items"));
    let map_data = [];
    selected_items.forEach((selected) => {
      let filter = pageData.filter((d) => d.RegistrationNo === selected);
      if (filter.length > 0) map_data.push(filter[0]);
    });
    show_map($(".map_btn"), map_data, map_data, false, pollutionType);
  }
}

function MobileInit() {
  let sortItemList = document.querySelector(".slide_down_block.sort_slide_down_block ul");
  Array.from(sortItemList.children).forEach((item) => {
    let sortType = item.getAttribute("data-value");
    if (sortType === filter_obj.FactOrder) {
      document.querySelector(".sort_block_mobile > .title").innerText = item.querySelector("button").innerText;
    }
    item.querySelector("button").addEventListener("click", function () {
      filter_obj.FactOrder = sortType;
      ChangeUrlSearch();
    });
  });
  document.getElementById("mobile_search_btn").addEventListener("click", MobileSearch);
  document.getElementById("mobile_clear_btn").addEventListener("click", MobileFilterClear);

  if (filter_obj.type == 3) {
    document.querySelector(".filter_keyword").addEventListener("input", function () {
      let reportItem = document.querySelector(".ReportItem");
      if (reportItem.value !== this.value) {
        reportItem.value = this.value;
      }
    });
    document.querySelector(".ReportItem").addEventListener("input", function () {
      let filterKeyword = document.querySelector(".filter_keyword");
      if (filterKeyword.value !== this.value) {
        filterKeyword.value = this.value;
      }
    });
  }
}

// 行動版搜尋
function MobileSearch() {
  let keyword = document.querySelector(".filter_keyword").value;
  if (!!keyword) {
    if (filter_obj.type == 3) {
      filter_obj.ReportItem = keyword;
    } else {
      filter_obj.Keyword = keyword;
    }
  }
  let location = document.getElementById("filter_location_input").value;
  if (!!location) {
    if (filter_obj.location !== location) {
      filter_obj.location = location;
      window.alert(filter_obj.location);
      filter_obj.placeId = places_changed[0].place_id;
      filter_obj.Lat = places_changed[0].geometry.location.lat();
      filter_obj.Lng = places_changed[0].geometry.location.lng();
    }
  }

  // let ReportItem = document.querySelector(".ReportItem").value;
  //if (!!ReportItem) filter_obj.ReportItem = ReportItem;

  let ReportValue = document.querySelector(".ReportValue").value;
  if (!!ReportValue) filter_obj.ReportValue = ReportValue;

  let insutryType = "";
  document.querySelectorAll(".insutry_type").forEach(function (parent, key) {
    if (key == 0) {
      Array.from(parent.children).forEach(function (child) {
        Array.from(child.querySelector(".sub_dropdown").children).forEach(function (el) {
          let input = el.querySelector("input");
          if (input.checked) {
            insutryType += "," + input.value;
          }
        });
      });
    }
  });
  if (!!insutryType) filter_obj.IndustryGroup = insutryType.replace(",", "");

  let townType = "";
  document.querySelectorAll(".town_type").forEach(function (parent, key) {
    if (key == 0) {
      Array.from(parent.children).forEach(function (child) {
        Array.from(child.querySelector(".sub_dropdown").children).forEach(function (el) {
          let input = el.querySelector("input");
          if (input.checked) {
            townType += "," + input.value;
          }
        });
      });
    }
  });
  filter_obj.Town = townType.replace(",", "");

  let riverArea = "";
  document.querySelectorAll(".river_area").forEach(function (parent, key) {
    if (key == 0) {
      Array.from(parent.children).forEach(function (child) {
        Array.from(child.querySelector(".sub_dropdown").children).forEach(function (el) {
          let input = el.querySelector("input");
          if (input.checked) {
            riverArea += "," + input.value;
          }
        });
      });
    }
  });
  filter_obj.RiverBasin = riverArea.replace(",", "");

  let IsPenalty = false,
    IsGreenhouse = false;
  document.querySelectorAll(".other_type").forEach(function (parent, key) {
    if (key == 0) {
      IsPenalty = parent.querySelector(".IsPenalty").checked;
      IsGreenhouse = parent.querySelector(".IsGreenhouse").checked;
    }
  });
  filter_obj.IsPenalty = IsPenalty ? IsPenalty : "";
  filter_obj.IsGreenhouse = IsGreenhouse ? IsGreenhouse : "";
  ChangeUrlSearch();
  //Search();
}

function MobileFilterClear() {
  document.querySelector(".ReportItem").value = "";
  document.querySelector(".ReportValue").value = 0;
  document.querySelector(".IndustryGroup").value = "";
  document.querySelector(".Town").value = "";
  document.querySelector(".RiverBasin").value = "";
  document.querySelector(".IsGreenhouse").value = "";
  document.querySelector(".IsPenalty").value = "";
  //var checked = $(".dropdown li .script input").attr();
  //for (var i = 0; i < checket.length; i++) {
  //    checket[i].checked = false;
  //}

  //let checkboxes = document.querySelectorAll('dropdown li .script input[type="checkbox"]');
  //let output = [];
  //checkboxes.forEach((checkbox) => {
  //    checkbox.removeAttribute('checked');
  //    alert(checkbox.prop('checked'));
  //});
  //    filter_obj.ReportItem= "";
  //    filter_obj.ReportValue= 0;
  //    filter_obj.IndustryGroup = "";
  //    filter_obj.Town = "";
  //    filter_obj.RiverBasin = "";
  //    filter_obj.IsGreenhouse = "";
  //    filter_obj.IsPenalty = "";
  //ChangeUrlSearch();
}
